<template>
  <div>
    <el-form
        ref="form"
        :model="info"
        status-icon
        label-position="right"
        label-width="6rem"
        size="mini"
        v-loading="loadings.main"
        @submit.native.prevent
        class="row"
        :rules="rules"
    >
      <div class="col-md-6">
        <div class="form-group" v-loading="loadings.customer">
          <div class="form-group-title">选择系统仓库</div>
          <warehouse-input v-model="info.warehouse"></warehouse-input>
        </div>
      </div>
    </el-form>
    <div class>
      <hr />
      <div class="dl total-show">
        <span class="dt">总数量</span>
        <span class="dd">{{total_amount}}</span>
        <span class="dt">总价格</span>
        <span class="dd">{{total_price}}</span>
      </div>
    </div>
    <reserve-order
        v-if="hasGetTableDataModel && info.warehouse._id"
        v-model="this.info.orderItems"
        :item-data = "this.info.orderItems"
        @select-change = "selectChangeHandel"
    ></reserve-order>
    <reserve-item
        :showSelect = true
        class="mt-3"
        @insert="onInsertItems($event)"
        :customer-id="info.customer._id"
        v-if="hasGetTableDataModel && info.warehouse._id"
        @selectChange = "selectChangeHandel"
    ></reserve-item>
    <hr />
    <div class="btn-holder text-center" v-loading="loadings.main">
      <el-button size type="success" :disabled="this.info.orderItems.length === 0" @click="handlerPost('edit')">保存</el-button>
    </div>
  </div>
</template>

<script>
import Order from "@/mixinsApp/Order.js";
import TxOp from "@/mixinsApp/TxOp.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import ReserveItem from "@/views/Reserve/Index.vue";
import ReserveOrder from "@/views/Reserve/subs/OrderItems.vue"
import WarehouseInput from "@/widgets/Inputs/WarehouseInput.vue";

export default {
  components: {WarehouseInput, ReserveItem, ReserveOrder},
  mixins: [Order, TxOp],
  config: {
    adminFilter: [
      {
        k: "is_leave",
        t: "bool",
        v: 0,
      },
      {
        k: "is_saler",
        t: "bool",
        v: 1,
      },
    ],
    customerFilter: [
      {
        k: "type",
        t: "int",
        lge : ">=",
        v: 0,
      }
    ],
  },
  data() {
    return {
      loadings: {
        main: false,
        create: false,
        insert: false,
        customer: false,
      },

      total_price_or:0,
      customerInfo: {},

      info: {
        customer: {
          _id: "",
        },
        warehouse:{
          _id:"",
        },
        discount: 0,
        items: [],
        orderItems:[],
      },
      addressField: {
        name: "address",
        params: {
          needFilter: true,
          kvFilter: [],
          allowCreate: false,
          isFreeMode: true,
        },
        nameFields: ["province", "address"],
        width: "100%",
        col: 6,
      },
      defaultValue: {
        customer: {
          name: "",
          _id: "",
          agent_level: 0,
          type: 1,
        },
        address: {
          _id: "",
          name: "",
          street: "",
          phone: "",
        },
      },
    };
  },
  computed: {
    ...mapState(["userPrivilegeMapping","configs"]),
    isCheckLessThanHolder() {
      // return true;
      if (this.userPrivilegeMapping[42]) {
        return false;
      } else {
        return true;
      }
    },
    total_amount() {
      let total_amount = 0;
      for (let k in this.info.orderItems) {
        total_amount += parseFloat(this.info.orderItems[k].order_amount);
      }
      return total_amount;
    },

    total_price() {
      let total_price = 0;

      for (let k in this.info.orderItems) {
        total_price += parseFloat(this.info.orderItems[k].order_amount * this.info.orderItems[k].price_per);
      }
      // this.total_price_or = total_price

      return parseFloat(total_price);
    },
    fields() {
      return []
    },
  },

  props: {
    recordId: {
      type: String,
      default: "",
    },
    value: {
      type: Object,
      default: null,
    },
  },
  methods: {
    handlerPost() {
      if (this.info.orderItems.length <= 0) {
        this.$message.error("尚未添加退库库存");
        return;
      }
      this.$refs["form"].validate(valid => {
        if (!valid) {
          this.$message.error("请检查输入");
          return false;
        }
        this.$confirm("是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(() => {
              this._doPost();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
      });
    },

    change(e){
      this.$forceUpdate()
    },
    _doPost(type) {
      this.loadings.main = true;
      let data = JSON.parse(JSON.stringify(this.info));
      data.warehouse = {
        _id: data.warehouse._id,
      };
      delete data.logs;
      delete data.customer;
      data.items = data.items.map(val => {
        return {
          _id: val._id,
          item: val.item,
          amount: val.amount,
          price_per: val.price_per,
          total_price: val.total_price,
          product_color: {
            _id: val.product_color._id,
          },
        };
      });
      this.$axios
          .post(`/reserve/do_rollback_item_multi`, data)
          .then(json => {
            this.loadings.main = false;
            this.$message.success("成功");
            this.$router.push({
              name: "Reserve-Log",
              params: {},
            });

          })
          .catch(json => {
            this.loadings.main = false;
            this.$message.error(json.data.msg);
          });
    },

    selectChangeHandel(val){
      for(let i in val){
        console.log("val[i]['order_amount']",typeof(val[i]['order_amount']))
        val[i]['total_price'] = val[i]['price_per'] * val[i]['order_amount']
      }
      this.info.orderItems.push(...val)
      this.info.orderItems = this.removeDuplicatesBy_Id(this.info.orderItems)
    },

    removeDuplicatesBy_Id(array) {
      const uniqueArray = array.reduce((acc, current) => {
        // 检查累加器数组中是否已有相同_id的元素
        const exists = acc.some((item) => item._id === current._id);
        // 如果没有，则添加到累加器数组中
        if (!exists) {
          acc.push(current);
        }
        return acc;
      }, []); // 初始化累加器为数组

      return uniqueArray;
    }
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.info = Object.assign({}, val);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style>
.el-radio-button--mini .el-radio-button__inner {
  padding: 7px 7px;
}
</style>
